 
export default (state = [], action) => {
    if (action.type === 'set_ultima_atualizacao') {
      return action.dados;
    }

    if (action.type === "define_ultima_atualizacao") {
      // console.log('chama videos cook ', document.cookie.split(";"));
 

      // const busca_cor_principal = async () => {
      //   const response = await Api.buscar("cor_principal", "", );

    
   
      // const condominio = Cookies.get("condominio");
      // if (condominio) {
      //   return condominio;
      // }
      // return "";
    }


    return state;
  };
  


// WEBPACK FOOTER //
// ./src/utils/reducerUltimaAtualizacao.js